import { computed } from 'vue';

export function useFeatures(domainRef) {
  const features = computed(() => {
    return domainRef.value?.session().company().features().find();
  });

  const hasFeatureVehicles = computed(() => features.value?.allowsVehicles() ?? false);
  const hasFeatureInspections = computed(() => features.value?.allowsInspections() ?? false);
  const hasFeatureTimesheets = computed(() => features.value?.allowsTimesheets() ?? false);
  const hasFeatureEquipment = computed(() => features.value?.allowsEquipment() ?? false);
  const hasFeatureEquipmentInspections = computed(() => features.value?.allowsEquipmentInspections() ?? false);
  const hasFeatureGpsDevices = computed(() => features.value?.allowsGpsDevice() ?? false);
  const hasFeatureMaps = computed(() => features.value?.allowsMap() ?? false);
  const hasFeatureDivisions = computed(() => features.value?.allowsDivisions() ?? false);
  const hasFeatureGroups = computed(() => features.value?.allowsLabels() ?? false);
  const hasFeatureLabels = computed(() => features.value?.allowsLabels() ?? false);
  const hasFeatureSso = computed(() => features.value?.allowsSso() ?? false);
  
  const company = computed(() => {
    const domain = domainRef;
    if (domain.value == null) {
      return null;
    }
    return domain.value?.session().company();
  });

  const showBulkOps = computed(() => {
    if (!company.value) return false;
    if (company.value.isNew()) {
      return false;
    }

    if (company.value.hasFeatureLabels()) {
      return true;
    }

    if (company.value.hasFeatureDivisions()) {
      return true;
    }
    return false;
  });

  return {
    showBulkOps,
    hasFeatureVehicles,
    hasFeatureInspections,
    hasFeatureTimesheets,
    hasFeatureEquipment,
    hasFeatureEquipmentInspections,
    hasFeatureGpsDevices,
    hasFeatureMaps,
    hasFeatureDivisions,
    hasFeatureGroups,
    hasFeatureLabels,
    hasFeatureSso,
  };
}